var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1418 106.588C14.8761 106.667 16.5178 107.393 17.7432 108.621C18.396 109.292 18.8829 110.106 19.1653 110.999C19.1793 110.306 19.1425 109.614 19.0551 108.927C18.8928 107.376 18.4982 105.858 17.8843 104.424L17.8677 104.38C17.3825 103.464 16.7443 102.636 15.9809 101.934C14.972 100.919 13.7152 100.185 12.3349 99.805C11.3561 99.5567 10.4387 99.11 9.63981 98.4929C8.84088 97.8757 8.17752 97.1012 7.69053 96.2174C7.14627 95.3066 6.75003 94.3152 6.51717 93.2803C6.25566 94.1283 6.09507 95.0041 6.03847 95.8897C5.87927 97.9771 6.21566 100.072 7.02012 102.005C7.41169 102.962 7.9885 103.832 8.71748 104.565C9.89836 105.752 11.4705 106.471 13.1418 106.588Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36488 93.5663C9.46409 94.8312 10.9863 95.6532 12.6477 95.8791C14.3734 96.0703 15.9648 96.9006 17.108 98.2062C17.7162 98.9189 18.1483 99.7644 18.3696 100.675C18.4281 99.9849 18.4376 99.2919 18.3982 98.6009C18.3353 97.0417 18.0409 95.5005 17.5244 94.0279L17.5078 93.9824C17.0848 93.0352 16.5018 92.1679 15.7841 91.4184C14.8483 90.3389 13.6429 89.5261 12.2909 89.0625C11.3303 88.7486 10.4442 88.2417 9.687 87.5729C8.92984 86.904 8.31769 86.0875 7.88823 85.1735C7.4047 84.2294 7.07435 83.2146 6.90921 82.167C6.5917 82.9953 6.37391 83.8585 6.26042 84.7382C5.96491 86.8117 6.16171 88.9255 6.83498 90.9089C7.16653 91.8859 7.68632 92.7887 8.36488 93.5663Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.855 117.578C13.2038 118.576 14.87 119.05 16.5426 118.91C18.2673 118.726 19.9984 119.194 21.3953 120.221C22.1443 120.786 22.7509 121.517 23.1669 122.357C23.0747 121.672 22.9331 120.995 22.7432 120.331C22.3451 118.821 21.724 117.379 20.9 116.052L20.876 116.012C20.258 115.179 19.5006 114.458 18.6374 113.883C17.4902 113.031 16.1384 112.498 14.7184 112.335C13.713 112.235 12.7387 111.931 11.8553 111.441C10.9718 110.951 10.1979 110.286 9.58072 109.487C8.90678 108.667 8.36612 107.746 7.97893 106.758C7.84477 107.636 7.81983 108.526 7.9047 109.41C8.05462 111.5 8.70074 113.524 9.78909 115.316C10.3233 116.197 11.025 116.966 11.855 117.578Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8407 129.674C22.5187 129.233 24.3009 129.433 25.8396 130.234C26.6666 130.677 27.3773 131.31 27.913 132.08C27.7187 131.416 27.4786 130.767 27.1947 130.136C26.5731 128.704 25.7411 127.373 24.7264 126.187L24.6905 126.156C23.9535 125.427 23.0968 124.83 22.1576 124.391C20.8911 123.725 19.4724 123.402 18.0422 123.453C17.0334 123.508 16.024 123.355 15.0768 123.005C14.1295 122.654 13.2646 122.112 12.5357 121.413C11.7449 120.705 11.0711 119.877 10.5391 118.959C10.5431 119.846 10.6524 120.729 10.8646 121.59C11.335 123.633 12.2835 125.535 13.6322 127.141C14.296 127.936 15.1093 128.594 16.0263 129.076C17.5069 129.847 19.2161 130.06 20.8407 129.674Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4684 140.62C24.0545 141.165 25.7841 141.117 27.3378 140.486C28.9298 139.795 30.723 139.723 32.3653 140.285C33.249 140.6 34.0458 141.118 34.6901 141.799C34.3992 141.17 34.0623 140.564 33.6821 139.984C32.8507 138.662 31.8258 137.472 30.6416 136.454L30.6057 136.42C29.7677 135.812 28.8316 135.352 27.8381 135.059C26.4859 134.592 25.0351 134.487 23.6295 134.753C22.6421 134.959 21.6227 134.961 20.6345 134.759C19.6463 134.557 18.7102 134.154 17.8836 133.576C16.9923 132.997 16.1995 132.28 15.5352 131.45C15.6683 132.328 15.9094 133.186 16.2532 134.005C17.0339 135.952 18.2644 137.687 19.8443 139.068C20.609 139.752 21.5006 140.279 22.4684 140.62Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3676 150.213C36.8357 149.289 38.5969 148.948 40.3042 149.256C41.2257 149.436 42.0923 149.828 42.8348 150.402C42.4513 149.825 42.0264 149.277 41.5635 148.761C40.5416 147.578 39.3493 146.554 38.0253 145.721L37.9844 145.7C37.0622 145.223 36.0657 144.907 35.0374 144.765C33.6305 144.506 32.1804 144.62 30.8311 145.095C29.885 145.448 28.8763 145.604 27.8674 145.553C26.8586 145.502 25.871 145.245 24.9655 144.798C24.0001 144.359 23.1111 143.769 22.332 143.05C22.5951 143.897 22.9627 144.709 23.4262 145.466C24.4848 147.273 25.9565 148.804 27.721 149.933C28.5881 150.497 29.5591 150.883 30.5771 151.067C32.2248 151.371 33.9268 151.068 35.3676 150.213Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5076 156.925C50.4448 156.966 51.3597 157.225 52.1796 157.68C51.7161 157.167 51.216 156.687 50.6833 156.245C49.4945 155.229 48.1605 154.395 46.7257 153.772L46.6828 153.753C45.7012 153.42 44.6692 153.258 43.6326 153.275C42.2022 153.229 40.7849 153.559 39.5222 154.231C38.6393 154.723 37.6649 155.028 36.6593 155.128C35.6538 155.229 34.6385 155.122 33.6758 154.815C32.6528 154.53 31.6824 154.082 30.8027 153.488C31.1892 154.285 31.6719 155.032 32.2394 155.712C33.5596 157.337 35.244 158.629 37.1567 159.484C38.0994 159.911 39.1172 160.147 40.1517 160.18C41.8286 160.232 43.4675 159.674 44.7627 158.608C46.077 157.472 47.7705 156.871 49.5076 156.925Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7614 163.126C60.6933 163.023 61.6364 163.14 62.5147 163.468C61.9779 163.03 61.4107 162.63 60.8173 162.272C59.4898 161.447 58.046 160.824 56.5342 160.426H56.4862C55.4651 160.245 54.4206 160.241 53.3981 160.414C51.977 160.58 50.6255 161.12 49.4814 161.978C48.6821 162.595 47.765 163.042 46.7863 163.292C45.8077 163.541 44.788 163.588 43.7905 163.43C42.737 163.295 41.7111 162.996 40.75 162.545C41.2573 163.273 41.8506 163.937 42.5169 164.523C44.0647 165.937 45.9266 166.963 47.9492 167.517C48.945 167.797 49.9864 167.878 51.0137 167.757C52.6786 167.553 54.2135 166.755 55.3348 165.508C56.4606 164.19 58.0398 163.34 59.7614 163.126Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8101 170.713C67.7254 169.24 69.1593 168.163 70.8296 167.694C71.7346 167.45 72.6847 167.423 73.6021 167.615C73.0075 167.262 72.3873 166.953 71.7467 166.692C70.3086 166.081 68.7879 165.685 67.2338 165.518H67.1763C66.1416 165.49 65.11 165.641 64.1264 165.963C62.7486 166.347 61.4954 167.085 60.492 168.103C59.7942 168.834 58.9544 169.415 58.024 169.809C57.0936 170.204 56.0922 170.405 55.0814 170.4C54.0203 170.428 52.9617 170.287 51.9453 169.981C52.5537 170.627 53.2396 171.196 53.9875 171.674C55.7325 172.842 57.7293 173.579 59.8146 173.827C60.8419 173.955 61.8843 173.877 62.8814 173.6C64.4983 173.146 65.8946 172.12 66.8101 170.713Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9506 174.146C79.632 172.553 80.887 171.273 82.4674 170.559C83.3256 170.182 84.2605 170.011 85.1967 170.061C84.553 169.806 83.8921 169.596 83.2191 169.432C81.7052 169.046 80.1427 168.885 78.5818 168.954H78.5341C77.5043 169.083 76.5047 169.39 75.5798 169.86C74.2763 170.448 73.1496 171.367 72.3119 172.525C71.7348 173.354 70.9931 174.056 70.1332 174.587C69.2733 175.118 68.3135 175.467 67.3131 175.613C66.2689 175.8 65.2014 175.822 64.1504 175.677C64.852 176.22 65.6156 176.679 66.4249 177.043C68.3282 177.927 70.4132 178.349 72.5107 178.277C73.544 178.246 74.561 178.011 75.5032 177.586C77.0326 176.896 78.2579 175.673 78.9506 174.146Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4246 171.605C95.2185 171.1 96.1211 170.79 97.058 170.703C96.382 170.546 95.6954 170.438 95.0038 170.38C93.447 170.22 91.875 170.294 90.3402 170.6L90.2923 170.612C89.2944 170.896 88.3533 171.35 87.5104 171.954C86.3099 172.73 85.3357 173.809 84.6855 175.082C84.2405 175.989 83.6143 176.794 82.8456 177.449C82.0768 178.105 81.1816 178.596 80.2156 178.892C79.2131 179.236 78.1632 179.421 77.1035 179.44C77.881 179.868 78.7062 180.204 79.5622 180.44C81.5764 181.022 83.6993 181.125 85.7604 180.739C86.7777 180.55 87.7477 180.163 88.6142 179.598C90.0218 178.688 91.0483 177.295 91.5013 175.682C91.9324 174.006 92.9751 172.552 94.4246 171.605Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.378 170.869C107.085 170.256 107.926 169.816 108.834 169.585C108.143 169.533 107.45 169.528 106.758 169.571C105.199 169.648 103.659 169.956 102.19 170.487L102.142 170.504C101.2 170.935 100.339 171.523 99.5929 172.242C98.5212 173.191 97.7166 174.403 97.2587 175.758C96.9538 176.72 96.4554 177.61 95.7943 178.373C95.1332 179.136 94.323 179.756 93.4137 180.195C92.4731 180.686 91.4608 181.024 90.4141 181.197C91.2452 181.505 92.1097 181.714 92.9899 181.819C95.0675 182.097 97.1816 181.881 99.1595 181.188C100.138 180.851 101.04 180.325 101.815 179.64C103.068 178.526 103.874 176.997 104.086 175.335C104.266 173.613 105.083 172.02 106.378 170.869Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.345 166.692C119.655 166.744 118.969 166.843 118.293 166.991C116.762 167.303 115.286 167.839 113.912 168.582L113.869 168.608C113.005 169.178 112.243 169.888 111.616 170.711C110.701 171.81 110.089 173.129 109.842 174.537C109.686 175.535 109.327 176.491 108.786 177.344C108.245 178.197 107.535 178.93 106.699 179.498C105.841 180.121 104.89 180.605 103.881 180.933C104.752 181.116 105.641 181.197 106.531 181.172C108.627 181.133 110.684 180.603 112.538 179.625C113.455 179.144 114.269 178.488 114.932 177.692C116.009 176.405 116.579 174.77 116.536 173.093C116.452 171.361 117.019 169.661 118.125 168.326C118.728 167.616 119.488 167.057 120.345 166.692Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.227 162.109C130.552 162.265 129.89 162.468 129.244 162.719C127.779 163.26 126.403 164.015 125.16 164.96L125.119 164.989C124.346 165.681 123.698 166.5 123.204 167.412C122.465 168.635 122.061 170.031 122.031 171.459C122.029 172.468 121.819 173.467 121.414 174.392C121.01 175.317 120.42 176.15 119.68 176.838C118.926 177.586 118.059 178.212 117.111 178.692C118 178.741 118.892 178.683 119.766 178.517C121.833 178.163 123.787 177.328 125.469 176.077C126.304 175.467 127.008 174.695 127.537 173.808C128.404 172.373 128.718 170.673 128.421 169.024C128.074 167.324 128.376 165.556 129.266 164.066C129.76 163.271 130.431 162.601 131.227 162.109Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.771 159.649L135.735 159.687C135.078 160.488 134.563 161.396 134.213 162.371C133.67 163.693 133.481 165.134 133.664 166.551C133.816 167.549 133.761 168.568 133.503 169.544C133.244 170.52 132.787 171.432 132.161 172.225C131.53 173.077 130.77 173.826 129.908 174.444C130.793 174.36 131.663 174.168 132.501 173.873C134.491 173.21 136.296 172.086 137.768 170.593C138.497 169.861 139.075 168.992 139.468 168.037C140.106 166.487 140.158 164.759 139.616 163.174C139.016 161.548 139.048 159.756 139.705 158.151C140.069 157.29 140.631 156.525 141.345 155.92C140.7 156.173 140.076 156.474 139.477 156.822C138.107 157.574 136.858 158.527 135.771 159.649Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.115 150.722C149.344 149.813 149.785 148.972 150.403 148.268C149.804 148.614 149.232 149.006 148.694 149.44C147.454 150.388 146.363 151.517 145.457 152.788L145.43 152.831C144.9 153.723 144.528 154.7 144.329 155.718C143.993 157.108 144.024 158.561 144.42 159.935C144.72 160.898 144.819 161.914 144.71 162.917C144.602 163.92 144.288 164.891 143.788 165.768C143.296 166.708 142.656 167.564 141.895 168.303C142.757 168.088 143.591 167.766 144.375 167.347C146.241 166.391 147.855 165.01 149.086 163.314C149.696 162.479 150.137 161.534 150.384 160.53C150.779 158.902 150.568 157.186 149.792 155.701C148.951 154.184 148.71 152.408 149.115 150.722Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.291 141.985C157.381 141.049 157.691 140.148 158.196 139.354C157.657 139.79 157.15 140.264 156.678 140.773C155.597 141.9 154.69 143.182 153.985 144.576L153.968 144.619C153.579 145.579 153.358 146.6 153.315 147.635C153.186 149.058 153.434 150.49 154.033 151.787C154.475 152.695 154.725 153.684 154.769 154.693C154.812 155.702 154.649 156.709 154.287 157.652C153.939 158.655 153.435 159.597 152.793 160.443C153.611 160.094 154.386 159.651 155.101 159.123C156.8 157.897 158.187 156.29 159.149 154.43C159.628 153.514 159.921 152.513 160.011 151.483C160.159 149.814 159.695 148.147 158.706 146.793C157.651 145.423 157.147 143.708 157.291 141.985Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.076 132.096C164.028 131.16 164.199 130.226 164.574 129.367C164.108 129.879 163.678 130.423 163.289 130.996C162.39 132.273 161.685 133.676 161.199 135.16L161.184 135.208C160.945 136.215 160.881 137.255 160.993 138.284C161.08 139.712 161.542 141.092 162.331 142.285C162.904 143.117 163.299 144.057 163.493 145.048C163.686 146.039 163.674 147.059 163.457 148.045C163.265 149.087 162.91 150.092 162.405 151.025C163.163 150.56 163.861 150.006 164.486 149.374C165.985 147.912 167.115 146.116 167.782 144.132C168.12 143.153 168.261 142.118 168.197 141.084C168.091 139.413 167.381 137.837 166.198 136.65C164.946 135.45 164.189 133.826 164.076 132.096Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.728 129.583C174.373 127.948 173.438 126.497 172.094 125.498C170.675 124.498 169.681 123.006 169.305 121.313C169.114 120.396 169.142 119.447 169.386 118.543C169.003 119.118 168.661 119.72 168.364 120.344C167.666 121.74 167.181 123.233 166.928 124.774V124.819C166.842 125.852 166.934 126.891 167.2 127.892C167.502 129.287 168.162 130.579 169.116 131.64C169.807 132.376 170.34 133.246 170.681 134.196C171.022 135.146 171.164 136.156 171.098 137.163C171.065 138.224 170.864 139.274 170.502 140.272C171.183 139.7 171.792 139.046 172.314 138.325C173.573 136.65 174.42 134.703 174.787 132.64C174.968 131.627 174.948 130.589 174.728 129.583Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.188 113.586C174.633 112.816 173.424 111.491 172.798 109.874C172.467 108.998 172.349 108.056 172.453 107.126C172.161 107.752 171.914 108.399 171.716 109.061C171.24 110.548 170.988 112.097 170.969 113.658V113.711C171.044 114.744 171.295 115.757 171.709 116.707C172.221 118.041 173.073 119.218 174.182 120.121C174.978 120.743 175.637 121.522 176.119 122.409C176.601 123.297 176.895 124.274 176.983 125.28C177.109 126.332 177.07 127.398 176.868 128.439C177.45 127.768 177.951 127.031 178.362 126.243C179.353 124.397 179.895 122.344 179.944 120.25C179.97 119.216 179.792 118.187 179.422 117.222C178.821 115.658 177.672 114.366 176.188 113.586Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.189 104.314C181.356 102.858 180.023 101.754 178.438 101.204C176.781 100.681 175.384 99.5524 174.523 98.0448C174.068 97.2265 173.81 96.3133 173.769 95.3779C173.576 96.0427 173.43 96.7206 173.333 97.4062C173.088 98.9486 173.074 100.519 173.293 102.065V102.113C173.52 103.124 173.921 104.088 174.478 104.962C175.186 106.204 176.208 107.24 177.442 107.964C178.322 108.458 179.091 109.129 179.702 109.932C180.313 110.736 180.752 111.657 180.992 112.637C181.283 113.658 181.405 114.72 181.354 115.78C181.831 115.032 182.216 114.229 182.5 113.388C183.202 111.413 183.424 109.3 183.149 107.222C183.024 106.199 182.698 105.21 182.189 104.314Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.368 93.8397C184.088 92.8464 183.613 91.9187 182.97 91.1107C181.933 89.7952 180.451 88.9024 178.802 88.5993C177.089 88.3227 175.541 87.4147 174.464 86.0545C173.89 85.3136 173.499 84.4472 173.324 83.5264C173.23 84.2127 173.184 84.9049 173.188 85.5977C173.177 87.1603 173.398 88.7159 173.844 90.2138V90.2592C174.221 91.2264 174.761 92.122 175.441 92.907C176.327 94.0288 177.493 94.8988 178.821 95.4303C179.766 95.7872 180.628 96.3335 181.353 97.0357C182.079 97.7378 182.652 98.5809 183.039 99.5131C183.478 100.479 183.759 101.51 183.87 102.565C184.231 101.753 184.49 100.9 184.641 100.025C185.04 97.9705 184.946 95.8511 184.368 93.8397Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.297 76.0802C175.561 76.0661 173.894 75.4031 172.624 74.2218C171.944 73.5774 171.427 72.7816 171.113 71.8994C171.12 72.5904 171.181 73.2798 171.297 73.9611C171.518 75.5061 171.968 77.0095 172.633 78.4218L172.657 78.4648C173.177 79.3605 173.845 80.1619 174.632 80.8351C175.68 81.8121 176.965 82.4982 178.36 82.825C179.347 83.0385 180.279 83.4517 181.1 84.0391C181.921 84.6265 182.612 85.3757 183.131 86.2405C183.71 87.1282 184.143 88.1029 184.412 89.1274C184.646 88.2692 184.775 87.3857 184.795 86.4964C184.882 84.4039 184.471 82.3206 183.598 80.4165C183.174 79.4739 182.565 78.6256 181.807 77.9219C180.578 76.7803 178.975 76.1254 177.297 76.0802Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.892 63.9347C172.173 64.1875 170.422 63.7872 168.984 62.813C168.215 62.2778 167.584 61.569 167.141 60.7441C167.255 61.4257 167.419 62.098 167.631 62.7556C168.09 64.2472 168.766 65.6632 169.638 66.958L169.667 66.9962C170.314 67.8056 171.095 68.4981 171.977 69.0436C173.159 69.8494 174.531 70.3318 175.958 70.4428C176.966 70.5042 177.951 70.7713 178.852 71.2275C179.753 71.6837 180.551 72.3193 181.196 73.0953C181.901 73.8892 182.475 74.7892 182.898 75.7621C182.997 74.881 182.989 73.9914 182.877 73.112C182.646 71.0284 181.922 69.0297 180.765 67.2809C180.199 66.4137 179.467 65.6667 178.611 65.0828C177.227 64.1451 175.552 63.7374 173.892 63.9347Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.689 52.4645C167.029 52.9728 165.239 52.8396 163.673 52.0913C162.833 51.6767 162.1 51.0724 161.533 50.3262C161.752 50.9822 162.017 51.6217 162.328 52.2396C163.006 53.645 163.889 54.9426 164.947 56.0904L164.981 56.1239C165.745 56.8251 166.623 57.3912 167.578 57.7981C168.867 58.4184 170.298 58.6881 171.725 58.5802C172.731 58.4873 173.746 58.6021 174.706 58.9172C175.667 59.2324 176.552 59.7413 177.308 60.4123C178.129 61.0913 178.834 61.8991 179.395 62.8041C179.362 61.9133 179.221 61.0298 178.974 60.1731C178.424 58.1509 177.404 56.2867 175.998 54.7319C175.31 53.9589 174.474 53.3312 173.539 52.8854C172.027 52.1635 170.303 52.0139 168.689 52.4645Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.812 41.8888C160.247 42.6391 158.457 42.7765 156.796 42.2739C155.899 41.9913 155.083 41.4994 154.414 40.8389C154.731 41.455 155.091 42.0488 155.489 42.616C156.369 43.9055 157.437 45.0559 158.659 46.0291L158.697 46.0602C159.559 46.6359 160.513 47.0613 161.517 47.3182C162.886 47.7354 164.34 47.7873 165.736 47.4689C166.716 47.2233 167.737 47.1815 168.734 47.346C169.731 47.5106 170.685 47.878 171.534 48.4256C172.446 48.9685 173.263 49.656 173.954 50.461C173.788 49.5877 173.514 48.7384 173.138 47.9329C172.292 46.0166 171.002 44.3286 169.375 43.0082C168.579 42.3475 167.658 41.853 166.667 41.554C165.061 41.0768 163.337 41.1956 161.812 41.8888Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.415 32.4878C151.981 33.4645 150.232 33.8689 148.514 33.6215C147.587 33.4768 146.707 33.1163 145.945 32.5692C146.348 33.1333 146.791 33.6673 147.272 34.1669C148.339 35.3082 149.568 36.2866 150.92 37.0705L150.961 37.0921C151.897 37.5354 152.902 37.8138 153.932 37.9148C155.348 38.1253 156.794 37.9603 158.126 37.4364C159.059 37.0484 160.062 36.8556 161.072 36.87C162.082 36.8844 163.078 37.1057 163.999 37.5201C164.984 37.9165 165.896 38.4725 166.7 39.1657C166.404 38.3294 166.007 37.5326 165.517 36.7931C164.39 35.0282 162.863 33.5532 161.059 32.4878C160.171 31.9607 159.187 31.6122 158.165 31.4618C156.509 31.2195 154.822 31.5839 153.415 32.4878Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.016 26.2994C138.079 26.2941 137.156 26.0696 136.322 25.644C136.805 26.1387 137.323 26.5983 137.871 27.0193C139.096 27.9882 140.458 28.7709 141.912 29.3418L141.956 29.3585C142.95 29.6568 143.988 29.7806 145.025 29.7244C146.455 29.7183 147.858 29.3373 149.095 28.6194C149.958 28.0959 150.92 27.7549 151.921 27.6175C152.921 27.4801 153.939 27.5492 154.912 27.8205C155.942 28.0688 156.926 28.4798 157.826 29.038C157.409 28.2606 156.897 27.5376 156.303 26.8854C154.924 25.3085 153.192 24.0793 151.247 23.2977C150.289 22.9049 149.263 22.7064 148.228 22.7141C146.551 22.7233 144.935 23.3404 143.679 24.4505C142.41 25.6261 140.746 26.2855 139.016 26.2994Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.553 20.4834C127.624 20.6216 126.676 20.5396 125.785 20.2442C126.337 20.6641 126.919 21.0415 127.528 21.3731C128.886 22.1412 130.349 22.7053 131.871 23.0473H131.919C132.946 23.1913 133.99 23.1573 135.005 22.9469C136.418 22.7264 137.747 22.1391 138.862 21.2439C139.636 20.5946 140.535 20.111 141.503 19.823C142.472 19.535 143.489 19.4488 144.493 19.5697C145.551 19.6638 146.587 19.9237 147.564 20.3399C147.033 19.6295 146.416 18.9869 145.728 18.4264C144.128 17.0724 142.229 16.116 140.188 15.6352C139.182 15.3936 138.138 15.3521 137.116 15.5132C135.46 15.7767 133.954 16.6306 132.879 17.917C131.81 19.284 130.266 20.1999 128.553 20.4834Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.221 13.1601C120.364 14.669 118.971 15.8011 117.318 16.3316C116.423 16.6079 115.475 16.6701 114.551 16.5134C115.161 16.8408 115.792 17.1254 116.442 17.3649C117.901 17.92 119.433 18.2584 120.991 18.3694H121.048C122.088 18.3628 123.118 18.175 124.093 17.8145C125.457 17.3798 126.682 16.5964 127.649 15.5423C128.316 14.7843 129.133 14.1719 130.048 13.7431C130.962 13.3143 131.956 13.0784 132.966 13.0501C134.025 12.981 135.089 13.0811 136.116 13.3466C135.484 12.7218 134.777 12.1772 134.012 11.7251C132.223 10.6323 130.201 9.97672 128.111 9.8116C127.08 9.72381 126.042 9.84005 125.056 10.1536C123.455 10.6581 122.092 11.7265 121.221 13.1601Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.954 10.2125C108.334 11.832 107.128 13.1607 105.576 13.9365C104.731 14.344 103.802 14.5496 102.863 14.5368C103.518 14.7672 104.189 14.9518 104.87 15.0893C106.397 15.419 107.964 15.5213 109.521 15.393H109.574C110.595 15.2199 111.58 14.8746 112.485 14.3718C113.769 13.7384 114.863 12.7771 115.655 11.5854C116.201 10.7365 116.915 10.0082 117.753 9.44547C118.591 8.88275 119.536 8.49746 120.529 8.31338C121.567 8.08574 122.635 8.02441 123.692 8.13163C122.971 7.61104 122.19 7.18048 121.365 6.84961C119.431 6.03916 117.333 5.6958 115.241 5.84744C114.209 5.91714 113.2 6.19026 112.274 6.65108C110.771 7.3955 109.591 8.66158 108.954 10.2125Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.6084 13.3162C92.8342 13.8464 91.946 14.1872 91.0156 14.3111C91.6975 14.4417 92.3881 14.5217 93.0818 14.5503C94.6433 14.6526 96.2113 14.5204 97.7335 14.1581H97.7814C98.7671 13.8386 99.6909 13.3533 100.513 12.723C101.683 11.9002 102.618 10.7864 103.226 9.49173C103.634 8.57047 104.227 7.74259 104.968 7.0593C105.709 6.376 106.583 5.85177 107.535 5.51896C108.53 5.13428 109.581 4.91141 110.647 4.85883C109.855 4.45644 109.017 4.14976 108.153 3.9452C106.119 3.4369 103.993 3.41476 101.949 3.8806C100.94 4.10559 99.9849 4.52738 99.1389 5.12189C97.7656 6.08483 96.7897 7.51381 96.3929 9.14247C96.0208 10.833 95.027 12.3225 93.6084 13.3162Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6903 14.4991C81.0046 15.1378 80.1789 15.6079 79.2793 15.8719C79.9701 15.9028 80.6623 15.8829 81.3501 15.8121C82.9066 15.6749 84.4345 15.3098 85.8846 14.7286L85.9276 14.7071C86.8557 14.2443 87.6973 13.6254 88.4152 12.8774C89.4479 11.8883 90.2052 10.6478 90.6129 9.27777C90.8807 8.30436 91.3458 7.39626 91.9791 6.60964C92.6125 5.82303 93.4005 5.17468 94.2949 4.70472C95.2162 4.17959 96.2151 3.80341 97.2541 3.59014C96.412 3.30973 95.5389 3.13222 94.654 3.06154C92.569 2.86044 90.4659 3.15382 88.5157 3.9178C87.5497 4.28971 86.6669 4.84895 85.9182 5.56331C84.7069 6.72054 83.9565 8.27734 83.8065 9.94505C83.6923 11.6731 82.938 13.2967 81.6903 14.4991Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8867 19.178C68.5748 19.1008 69.2566 18.9745 69.9266 18.8C71.4414 18.4289 72.8931 17.8374 74.2357 17.0445L74.2717 17.0206C75.1183 16.4215 75.8554 15.6811 76.4504 14.8321C77.3229 13.7002 77.885 12.3606 78.0808 10.9454C78.1991 9.94243 78.5221 8.97445 79.0303 8.1014C79.5385 7.22835 80.2208 6.4689 81.0348 5.87013C81.8674 5.21236 82.8003 4.69228 83.7977 4.3298C82.9215 4.17736 82.0298 4.13238 81.1427 4.19586C79.0482 4.30992 77.0105 4.91721 75.1958 5.96816C74.3013 6.48498 73.5154 7.16966 72.8809 7.98447C71.8492 9.31046 71.3381 10.9675 71.4442 12.6436C71.5905 14.3702 71.0878 16.0892 70.0341 17.4654C69.4609 18.1949 68.7258 18.7812 67.8867 19.178Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1602 24.1643C57.8306 23.9862 58.487 23.7584 59.1235 23.4826C60.5678 22.887 61.916 22.081 63.124 21.0908L63.1573 21.0621C63.9007 20.3405 64.5147 19.4967 64.9722 18.5675C65.6649 17.3169 66.0174 15.9067 65.9944 14.4776C65.96 13.4685 66.1335 12.4631 66.5041 11.5238C66.8748 10.5845 67.4347 9.73126 68.1492 9.01711C68.8721 8.2391 69.715 7.58181 70.6461 7.07022C69.7607 7.05401 68.8766 7.14394 68.0127 7.3381C65.9594 7.7707 64.037 8.68024 62.401 9.99301C61.594 10.6375 60.9212 11.4338 60.421 12.3369C59.6092 13.8041 59.36 15.5165 59.7196 17.154C60.1322 18.8387 59.8963 20.6168 59.0589 22.1361C58.5953 22.9525 57.9445 23.6475 57.1602 24.1643Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.737 26.8044L52.7683 26.7662C53.3937 25.9396 53.8738 25.0126 54.188 24.0251C54.6838 22.6842 54.8183 21.2368 54.5782 19.8276C54.3904 18.8356 54.4081 17.8156 54.6305 16.8308C54.8529 15.8459 55.2752 14.9171 55.8711 14.1017C56.4695 13.2256 57.2023 12.4491 58.0425 11.8008C57.1626 11.919 56.3002 12.1423 55.4736 12.4657C53.5105 13.2029 51.7494 14.3928 50.3336 15.9386C49.6307 16.6964 49.0847 17.5857 48.7271 18.5552C48.149 20.1301 48.1618 21.8609 48.7631 23.4272C49.4229 25.0304 49.4579 26.8223 48.8613 28.4499C48.5296 29.3263 47.9956 30.1122 47.3027 30.7437C47.9366 30.4684 48.5502 30.1487 49.1389 29.787C50.4785 28.9748 51.6907 27.9698 52.737 26.8044Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7374 36.1949C39.5375 37.1087 39.1277 37.9635 38.5403 38.6919C39.1287 38.3225 39.6888 37.9099 40.2161 37.4577C41.4195 36.46 42.4685 35.2897 43.3285 33.9848L43.3548 33.9442C43.8479 33.0332 44.1846 32.0461 44.3508 31.0239C44.6368 29.6219 44.5491 28.1695 44.0968 26.8119C43.763 25.8596 43.628 24.8491 43.6996 23.8426C43.7713 22.836 44.0482 21.8548 44.5135 20.9593C44.9721 20.0035 45.5789 19.126 46.3114 18.3594C45.4597 18.6089 44.6414 18.9607 43.8744 19.4069C42.049 20.4316 40.4906 21.8713 39.3256 23.6093C38.7486 24.4662 38.3422 25.426 38.1286 26.4364C37.7923 28.0797 38.0652 29.7892 38.8969 31.2463C39.7855 32.7332 40.0854 34.4984 39.7374 36.1949Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8638 45.2406C31.8062 46.1764 31.5298 47.0857 31.0569 47.8955C31.5772 47.4404 32.0651 46.9496 32.5173 46.427C33.5569 45.2588 34.4177 43.9435 35.0718 42.5236L35.0888 42.4805C35.4421 41.5065 35.625 40.479 35.6297 39.443C35.7041 38.0148 35.402 36.5921 34.7536 35.3172C34.2772 34.4258 33.989 33.4463 33.9066 32.4392C33.8243 31.4321 33.9494 30.4189 34.2746 29.4621C34.5856 28.4494 35.0536 27.4914 35.661 26.623C34.8559 26.9995 34.0987 27.4709 33.4057 28.027C31.7508 29.3111 30.4246 30.9695 29.5367 32.8656C29.0899 33.7983 28.8336 34.8106 28.7827 35.8434C28.696 37.5163 29.2208 39.1637 30.2597 40.4786C31.3713 41.8099 31.9436 43.5088 31.8638 45.2406Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1676 50.8881C24.4641 52.0421 25.2806 53.6396 25.4562 55.3655C25.5378 56.2973 25.4028 57.2354 25.0614 58.1064C25.5062 57.5764 25.9149 57.0171 26.2847 56.4322C27.1323 55.1207 27.7822 53.6919 28.2141 52.1916L28.2287 52.1462C28.4281 51.1294 28.454 50.0862 28.3053 49.0608C28.1641 47.639 27.6504 46.2795 26.816 45.1191C26.2136 44.3083 25.7841 43.3827 25.5535 42.3996C25.3229 41.4165 25.2964 40.3966 25.4755 39.4028C25.6292 38.3523 25.9526 37.3336 26.4332 36.3867C25.6917 36.8771 25.0122 37.4553 24.41 38.1088C22.9634 39.6276 21.8971 41.4668 21.2978 43.476C21.0007 44.4651 20.8998 45.5025 21.0009 46.5302C21.1727 48.1966 21.9424 49.7445 23.1676 50.8881Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7229 62.2684C19.1755 63.2111 20.2245 64.6607 20.6652 66.3343C20.8862 67.2435 20.8936 68.1915 20.6868 69.1041C21.0503 68.5166 21.3704 67.9035 21.6445 67.2696C22.2868 65.8455 22.7142 64.3343 22.9132 62.785V62.7395C22.9556 61.7052 22.8238 60.6711 22.523 59.6805C22.1667 58.2963 21.4535 57.0296 20.4545 56.0067C19.7376 55.2956 19.1736 54.4459 18.7969 53.5094C18.4202 52.573 18.239 51.5695 18.2641 50.5606C18.2564 49.4997 18.4179 48.4445 18.7428 47.4346C18.0844 48.0311 17.5016 48.7058 17.0072 49.4437C15.8102 51.163 15.0367 53.1405 14.7496 55.215C14.6026 56.2381 14.6594 57.2802 14.917 58.2812C15.3369 59.9064 16.3342 61.3236 17.7229 62.2684Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0626 74.3092C15.6459 75.0223 16.9042 76.3024 17.5891 77.8969C17.9492 78.7617 18.1011 79.699 18.0322 80.6331C18.3006 79.9939 18.5247 79.337 18.7026 78.6671C19.1168 77.1628 19.3078 75.6059 19.2698 74.0461V73.9935C19.1565 72.9645 18.8684 71.9623 18.4176 71.0301C17.8543 69.7147 16.9563 68.5694 15.8129 67.7079C14.9969 67.1138 14.3108 66.3596 13.7967 65.4914C13.2825 64.6233 12.951 63.6595 12.8226 62.6589C12.6587 61.6097 12.6587 60.5414 12.8226 59.4922C12.2655 60.184 11.7916 60.9385 11.4102 61.7405C10.4897 63.624 10.0279 65.6982 10.0623 67.794C10.0719 68.8286 10.2857 69.8512 10.6918 70.8029C11.3552 72.3397 12.5523 73.585 14.0626 74.3092Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59524 82.4759C9.48477 83.8982 10.8589 84.9514 12.4643 85.4417C14.1359 85.9052 15.572 86.979 16.4885 88.4506C16.9791 89.2523 17.2722 90.1589 17.3433 91.0958C17.8767 88.9028 17.9581 86.6244 17.5827 84.3989L17.5707 84.3511C17.3042 83.3498 16.8678 82.4017 16.2804 81.5479C15.5278 80.3316 14.4674 79.335 13.2063 78.6586C12.307 78.1967 11.5126 77.5548 10.8721 76.7731C10.2317 75.9913 9.75914 75.0863 9.48366 74.1143C9.16145 73.102 8.99972 72.0456 9.00467 70.9834C8.55933 71.7524 8.20664 72.5713 7.95376 73.4231C7.3278 75.4221 7.18412 77.5407 7.53468 79.6058C7.69744 80.6224 8.05772 81.5975 8.59524 82.4759Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3297 93.5895C33.3057 94.5359 33.5632 95.4681 34.0699 96.2681C34.5766 97.0681 35.3095 97.6999 36.1758 98.0835C37.0421 98.4672 38.0031 98.5853 38.9367 98.4231C39.8703 98.2609 40.7347 97.8256 41.4205 97.1723C42.1063 96.519 42.5825 95.6771 42.789 94.7532C42.9956 93.8292 42.9233 92.8648 42.581 91.9821C42.2386 91.0993 41.6418 90.3379 40.8661 89.7942C40.0903 89.2505 39.1704 88.9491 38.223 88.928C36.9559 88.8997 35.7292 89.3745 34.8119 90.2483C33.8946 91.1221 33.3617 92.3237 33.3297 93.5895Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.474 93.8093C158.493 92.8641 158.232 91.9344 157.723 91.1374C157.214 90.3404 156.48 89.7119 155.614 89.3314C154.748 88.9508 153.788 88.8353 152.856 88.9993C151.924 89.1632 151.062 89.5994 150.378 90.2527C149.694 90.906 149.219 91.7471 149.013 92.6699C148.807 93.5926 148.88 94.5556 149.221 95.4372C149.563 96.3189 150.158 97.0796 150.933 97.6233C151.707 98.1671 152.625 98.4696 153.571 98.4924C154.201 98.5077 154.828 98.3985 155.415 98.1712C156.003 97.9439 156.54 97.603 156.995 97.1679C157.451 96.7328 157.816 96.2122 158.07 95.6359C158.323 95.0595 158.461 94.4388 158.474 93.8093Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_1075_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.641 55.0927C134.862 54.3138 133.938 53.6959 132.921 53.2743C131.903 52.8527 130.812 52.6357 129.711 52.6357C128.609 52.6357 127.518 52.8527 126.501 53.2743C125.483 53.6959 124.559 54.3138 123.781 55.0927L97.7785 81.0722L71.7717 55.0927C70.1989 53.5214 68.0658 52.6387 65.8415 52.6387C63.6173 52.6387 61.4842 53.5214 59.9114 55.0927C58.3386 56.664 57.4551 58.795 57.4551 61.0171C57.4551 63.2392 58.3386 65.3703 59.9114 66.9416L85.9182 92.9211L59.9162 118.901C59.1374 119.678 58.5196 120.602 58.0981 121.618C57.6765 122.634 57.4594 123.723 57.4592 124.823C57.4589 125.923 57.6756 127.013 58.0968 128.029C58.5179 129.045 59.1354 129.969 59.9138 130.747C60.6923 131.525 61.6165 132.142 62.6337 132.563C63.6509 132.985 64.7411 133.201 65.8422 133.202C66.9433 133.202 68.0337 132.985 69.0511 132.565C70.0684 132.144 70.9929 131.527 71.7717 130.749L97.7785 104.77L123.783 130.749C125.356 132.321 127.489 133.203 129.713 133.203C131.937 133.203 134.07 132.321 135.643 130.749C137.216 129.178 138.099 127.047 138.099 124.825C138.099 122.603 137.216 120.472 135.643 118.901L109.639 92.9211L135.641 66.9416C136.42 66.164 137.039 65.2406 137.461 64.224C137.883 63.2074 138.1 62.1177 138.1 61.0171C138.1 59.9166 137.883 58.8269 137.461 57.8103C137.039 56.7937 136.42 55.8702 135.641 55.0927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1075_97",
    x: 0,
    y: 90.2803,
    width: 25.168,
    height: 29.7178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1075_97",
    x: 0.126953,
    y: 79.167,
    width: 24.2949,
    height: 30.5078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1075_97",
    x: 1.85547,
    y: 103.758,
    width: 27.3105,
    height: 27.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1075_97",
    x: 4.53906,
    y: 115.959,
    width: 29.373,
    height: 25.1211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1075_97",
    x: 9.53516,
    y: 128.45,
    width: 31.1543,
    height: 22.3496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1075_97",
    x: 16.332,
    y: 140.05,
    width: 32.502,
    height: 20.1318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1075_97",
    x: 24.8027,
    y: 150.271,
    width: 33.377,
    height: 18.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1075_97",
    x: 34.75,
    y: 157.287,
    width: 33.7656,
    height: 19.5244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1075_97",
    x: 45.9453,
    y: 162.515,
    width: 33.6562,
    height: 20.3721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1075_97",
    x: 58.1504,
    y: 165.938,
    width: 33.0469,
    height: 21.3467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1075_97",
    x: 71.1035,
    y: 167.298,
    width: 31.9551,
    height: 22.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1075_97",
    x: 84.4141,
    y: 166.542,
    width: 30.4199,
    height: 24.3945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1075_97",
    x: 97.8809,
    y: 163.692,
    width: 28.4648,
    height: 26.4844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1075_97",
    x: 111.111,
    y: 159.109,
    width: 26.1152,
    height: 28.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_1075_97",
    x: 123.908,
    y: 152.92,
    width: 23.4355,
    height: 30.5244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1075_97",
    x: 135.895,
    y: 145.268,
    width: 20.6836,
    height: 32.0361,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1075_97",
    x: 146.793,
    y: 136.354,
    width: 19.2461,
    height: 33.0879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_1075_97",
    x: 154.939,
    y: 126.367,
    width: 19.2715,
    height: 33.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_1075_97",
    x: 160.896,
    y: 115.543,
    width: 20.0137,
    height: 33.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_1075_97",
    x: 164.969,
    y: 104.126,
    width: 20.9785,
    height: 33.3135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_1075_97",
    x: 167.139,
    y: 92.3779,
    width: 22.125,
    height: 32.4023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_1075_97",
    x: 167.188,
    y: 80.5264,
    width: 23.6953,
    height: 31.0391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_1075_97",
    x: 165.113,
    y: 68.8994,
    width: 25.6934,
    height: 29.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_1075_97",
    x: 161.141,
    y: 57.7441,
    width: 27.8262,
    height: 27.0176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_1075_97",
    x: 155.533,
    y: 47.3262,
    width: 29.8613,
    height: 24.4775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_1075_97",
    x: 148.414,
    y: 37.8389,
    width: 31.541,
    height: 21.6221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_1075_97",
    x: 139.945,
    y: 28.3887,
    width: 32.7539,
    height: 19.7773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_1075_97",
    x: 130.322,
    y: 19.7139,
    width: 33.5039,
    height: 19.0234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_1075_97",
    x: 119.785,
    y: 12.417,
    width: 33.7793,
    height: 19.7178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_1075_97",
    x: 108.551,
    y: 6.7832,
    width: 33.5664,
    height: 20.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_1075_97",
    x: 96.8633,
    y: 2.8125,
    width: 32.8281,
    height: 21.6338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_1075_97",
    x: 85.0156,
    y: 0.546875,
    width: 31.6309,
    height: 23.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_1075_97",
    x: 73.2793,
    y: 0,
    width: 29.9746,
    height: 24.8857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_1075_97",
    x: 61.8867,
    y: 1.16797,
    width: 27.9102,
    height: 27.0098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_1075_97",
    x: 51.1602,
    y: 4.06836,
    width: 25.4863,
    height: 29.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_1075_97",
    x: 41.3027,
    y: 8.80078,
    width: 22.7402,
    height: 30.9434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_1075_97",
    x: 31.9883,
    y: 15.3594,
    width: 20.3223,
    height: 32.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_1075_97",
    x: 22.7734,
    y: 23.623,
    width: 18.8867,
    height: 33.2725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_1075_97",
    x: 14.9629,
    y: 33.3867,
    width: 19.4375,
    height: 33.7197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_1075_97",
    x: 8.66992,
    y: 44.4346,
    width: 20.252,
    height: 33.6699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_1075_97",
    x: 4.06055,
    y: 56.4922,
    width: 21.2148,
    height: 33.1406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_1075_97",
    x: 1.34766,
    y: 67.9834,
    width: 22.4668,
    height: 32.1123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_1075_97",
    x: 27.3281,
    y: 85.9268,
    width: 21.5762,
    height: 21.5674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_1075_97",
    x: 142.898,
    y: 85.9268,
    width: 21.5762,
    height: 21.5674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_1075_97",
    x: 51.4551,
    y: 49.6357,
    width: 92.6445,
    height: 92.5674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.082 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_97"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_97",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.d70163976f031e30c538a5d7b57afec7.svg";
export { ForwardRef as ReactComponent };